
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex'
import { menuItems } from '@/constant/menuItems'
import { facebookUrlGroup } from '@/constant/facebook'

export default defineComponent({
  name: 'MobileMenu',
  data () {
    return {
      open: false,
      fbUrl: facebookUrlGroup,
      menuItems
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'global/getIsMobile'
    })
  },
  methods: {
    toggleMenu () {
      this.open = !this.open;
    }
  }
});
